import './enhanced-text-input.scss'

import { FormApi } from 'final-form';
import { set } from 'lodash';
import Component from 'vue-class-component';

import { faBarcode, faEraser } from '@fortawesome/free-solid-svg-icons';
import { ReactiveVue } from '@skinsoft/reactive-vue';

@Component({
    props: ['defaultValue', 'form', 'name', 'autoUpdate'],
    template: require('./enhanced-text-input.html'),
})
export class EnhancedTextInput<T> extends ReactiveVue {
    public defaultValue: string;
    public form: FormApi;
    public name: string;
    public autoUpdate: boolean;

    public scanIcon = faBarcode;
    public clearIcon = faEraser;

    public eraseInput() {
        this.setFieldValue("");
    }

    public mounted() {
        this.setFieldValue(this.defaultValue);

        this.$on('field-value-changed', (message) =>
            this.$parent.$emit('field-value-changed', message)
        )
    }

    private setFieldValue(value: string) {
        set(this.form.getState().values, this.name, value)
        this.form.mutators.setFieldTouched(this.name);
    }


}